import TimeHorizontalBars from "./TimeHorizontalBars";

export default TimeHorizontalBars;
